export default __webpack_public_path__ + "static/media/logo.23e28301.png";